import financialSubaccountForm from '../financial-subaccount/financial-subaccount.form';
import { CustomComponentType } from '../../../../enums/custom-component-type';

export default function(...extend: any) {
	return financialSubaccountForm(CustomComponentType.retirementAccount, ...extend);
}
